import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=f2a9a8b4&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2a9a8b4')) {
      api.createRecord('f2a9a8b4', component.options)
    } else {
      api.reload('f2a9a8b4', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=f2a9a8b4&", function () {
      api.rerender('f2a9a8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Home/Banner.vue"
export default component.exports